import React from 'react';
import FormSelect from 'shared/forms/FormSelect';
import { FormMultiSelect } from '../formControls';
import { useGetChassisPoolsLookup } from 'src/fetch/chassisPool';

const ChassisPoolsDropdown = (props) => {
  const { data: chassisPools } = useGetChassisPoolsLookup();

  const SelectComponent = props.multiSelect ? FormMultiSelect : FormSelect;

  return (

    <SelectComponent
      data={chassisPools}
      textField="abbreviation"
      dataItemKey="id"
      {...props}
    />
  );
};

export default ChassisPoolsDropdown;